module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', [_vm._m(2), _vm._v(" "), _vm._l((_vm.monies), function(money) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(money.contract_money_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_ref))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "cnpro-accounts"
      }
    }, [_vm._v(_vm._s(money.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_contract_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.contract_money_pay_out_amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "uppercase"
      },
      style: ({
        color: money.contract_money_status_color,
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(money.contract_money_status))]), _vm._v(" "), (money.contract_money_status_id == 1) ? _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#banking"
      },
      on: {
        "click": function($event) {
          _vm.setPayment(money)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    }), _vm._v(" Pay Me")])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "background-white p20 mb30 hidden-md hidden-lg"
  }, _vm._l((_vm.monies), function(money) {
    return _c('div', [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(" " + _vm._s(money.contract_money_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("REF: ")]), _vm._v(" " + _vm._s(money.contract_money_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("CNpro: ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "cnpro-accounts"
      }
    }, [_vm._v(_vm._s(money.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Contract ID: ")]), _vm._v(" " + _vm._s(money.contract_money_contract_ref))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Contract Amount: ")]), _vm._v(" ₦" + _vm._s(money.contract_money_pay_out_amount))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      },
      style: ({
        color: money.contract_money_status_color,
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(money.contract_money_status))])]), _vm._v(" "), (money.contract_money_status_id == 1) ? _c('p', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#banking"
      },
      on: {
        "click": function($event) {
          _vm.setPayment(money)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    }), _vm._v(" Pay Me")])]) : _vm._e(), _vm._v(" "), _c('hr')])
  }))])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "banking",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Bank details")]), _vm._v(" "), (_vm.bank_set) ? _c('div', [_c('h5', [_vm._v("Bank Name: " + _vm._s(_vm.bank.bank_name))]), _vm._v(" "), _c('h5', [_vm._v("Account Name: " + _vm._s(_vm.bank.account_name))]), _vm._v(" "), _c('h5', [_vm._v("Account Number: " + _vm._s(_vm.bank.account_number))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editBank
    }
  }, [_vm._v("Edit Setting")]), _vm._v(" "), (_vm.payment_request) ? _c('div', [_c('h2', [_vm._v("Request Payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Contract: "), _c('b', [_vm._v(_vm._s(_vm.money.contract_money_contract_ref))])]), _vm._v(" "), _c('h6', [_vm._v("Labour Cost: "), _c('b', [_vm._v("₦" + _vm._s(_vm.money.contract_money_labour_cost))])]), _vm._v(" "), _c('h6', [_vm._v("Service Charge(incl. of VAT): "), _c('b', [_vm._v(_vm._s(_vm.money.contract_money_set_service_charge) + "%")])]), _vm._v(" "), _c('h6', [_vm._v("---------")]), _vm._v(" "), _c('h6', [_vm._v("Total Money after VAT and Service Charge deductions: "), _c('b', [_c('span', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("₦" + _vm._s(_vm.money.contract_money_pay_out_amount))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.processPayment
    }
  }, [_vm._v("Receive Payment")])]) : _vm._e()]) : _c('div', [(_vm.bank.length == null || _vm.editBankFlag) ? _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bank Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.bank_name),
      expression: "bank.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Bank Name"
    },
    domProps: {
      "value": (_vm.bank.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Account Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.account_name),
      expression: "bank.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Account Name"
    },
    domProps: {
      "value": (_vm.bank.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Account Numbr")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank.account_number),
      expression: "bank.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your Account Number"
    },
    domProps: {
      "value": (_vm.bank.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank.account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.editBankFlag) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateBankSetting
    }
  }, [_vm._v("Save")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setBanking
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Your Information is safe. You can always edit these details later")])])]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Money Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p20 mb30"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl pull-left",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#banking"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Set Up Bank Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~")]), _vm._v(" "), _c('th', [_vm._v("REF")]), _vm._v(" "), _c('th', [_vm._v("CNpro")]), _vm._v(" "), _c('th', [_vm._v("Contract ID")]), _vm._v(" "), _c('th', [_vm._v("Contract Amount(₦)")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" --- ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3b19640"}!./src/components/MyMoney/template.html
// module id = 322
// module chunks = 0